// extracted by mini-css-extract-plugin
export default {"menuItem__link":"footerMenuItem_menuItem__link__H5iD6"};